import {ErrorMessage} from 'formik'
import {FC} from 'react'

import {TrademarkDropzone} from '@/components/common/dropzone/TrademarkDropzone'
import {FormErrorMessage} from '@/components/common/form/FormErrorMessage'
import {FormItem} from '@/components/common/form/FormItem'
import {FormSection} from '@/components/common/form/FormSection'
import {TextInput} from '@/components/inputs/TextInput'
import {useTrademarkVerificationContent} from '@/content/trademarkVerification'
import {useTranslation} from '@/i18n'
import {TrademarkTypeValue, VerificationTrademarkTypeValue} from '@/utils/constants'

type TrademarkDefinitonProps = {
  type: TrademarkTypeValue
  typeValue?: VerificationTrademarkTypeValue
}

export const TrademarkDefiniton: FC<React.PropsWithChildren<TrademarkDefinitonProps>> = ({
  type,
  typeValue,
}) => {
  const {t} = useTranslation()
  const {dropzone, wordTrademark} = useTrademarkVerificationContent()

  return (
    <>
      {type === TrademarkTypeValue.text ? (
        <FormSection title={t(wordTrademark.title)}>
          <FormItem>
            <ErrorMessage name="value" render={(msg) => <FormErrorMessage message={t(msg)} />} />
            <TextInput
              name="value"
              placeholder={t(wordTrademark.placeholder)}
              data-test={wordTrademark.dataTest}
            />
          </FormItem>
        </FormSection>
      ) : (
        <FormSection
          title={
            typeValue === VerificationTrademarkTypeValue.logo
              ? t(dropzone.logoTitle)
              : t(dropzone.figurativeTitle)
          }
        >
          <TrademarkDropzone />
        </FormSection>
      )}
    </>
  )
}
